import React from 'react';
import NavBar from './NavBar';
import UIToggleWrapper from '../../shared/UIToggleWrapper/UIToggleWrapper';
import UILayout from '../../shared/UILayout/UILayout';

interface WrapperProps {
  children?: React.ReactNode;
}

const NavBarIndex = UIToggleWrapper<WrapperProps>(NavBar, UILayout);

export default NavBarIndex;
